import { useContext } from 'react'

import { UserSessionContext } from '../../context/UserSessionContext'

export const useUserSession = () => useContext(UserSessionContext)
